import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useParams } from "react-router-dom";
import Sidebar from "../../../../../partials/aside/Sidebar";
import httpService from "../../../../../../services/httpServices/httpServices";
import validateFormEditCampaign from "../../../../../../validtions/forms/campaign/banner/edit";
import TypeGroupCampaign from "../../../TypeGroupCampaign";
import helperSpinner from "../../../../../../helpers/spinner";

function EditCampaign() {
  const params = useParams();
  const campaignID = params.id;
  const userID = params.userID;

  const initCampaign = {
    name: "",
    category: "",
  };

  const history = useHistory();
  const [tagCategories, setTagCategories] = useState(<></>);
  const [campaign, setCampaign] = useState(initCampaign);
  const [message, setMessage] = useState();

  let messageTag;

  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  useEffect(() => {
    getCategoriesUserSitesPublisher().then(() => {
      getCampaignInfo(campaignID);
    });
  }, []);

  const getCategoriesUserSitesPublisher = async () => {
    let categories = await sendRequestGetCategoriesUserSitesPublisher();
    categories = filterCategoriesUserSitesPublisherType(
      categories,
      TypeGroupCampaign.typeGroupPublisher.NATIVE
    );
    setTagCategories(generateTagCategories(categories));
  };

  const filterCategoriesUserSitesPublisherType = (categories, type) => {
    return categories.filter((category) => {
      category.id = category.cau_id;
      category.name = category.cau_name;
      if (category.type == type) {
        return category;
      }
    });
  };

  const sendRequestGetCategoriesUserSitesPublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const headersRequest = getHeaderForRequest();
    let categoryAllPublisher;
    try {
      categoryAllPublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/manage/category-user-site-publishers/user/" +
          userID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return categoryAllPublisher.data.data;
  };

  const generateTagCategories = (categories) => {
    return categories.map((category, index) => {
      return (
        <>
          <option key={index} value={category.id}>
            {category.name}
          </option>
        </>
      );
    });
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getCampaignInfo = async (campaignID) => {
    const campaignInfo = await sendRequestGetCampaignInfo(campaignID);
    setCampaign(campaignInfo);
    document.getElementById("category-campaign").value =
      campaignInfo.category_id;
  };

  const sendRequestGetCampaignInfo = async (campaignID) => {
    const headersRequest = getHeaderForRequest();
    let campaignInfo;
    try {
      campaignInfo = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/campaign/manage/native/simple/" +
          campaignID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return campaignInfo.data.data;
  };

  const sendForm = async (e) => {
    e.preventDefault();
    const dataForm = getFormData();

    if (validateFormEditCampaign(dataForm) != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: validateFormEditCampaign(dataForm),
        class_icon: "fa fa-exclamation-triangle",
      });

      return;
    }

    if (await sendRequestEditCampaignInfo(campaignID, dataForm)) {
      history.push("/campaigns/manage/all");
    }
  };

  const getFormData = () => {
    return {
      name: document.querySelector("#name-campaign").value,
      category_id: document.querySelector("#category-campaign").value,
      active: document.querySelector("#active-campaign").checked ? "1" : "0",
    };
  };

  const sendRequestEditCampaignInfo = async (campaignID, data) => {
    const headersRequest = getHeaderForRequest();
    let campaignInfo;
    try {
      campaignInfo = await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/campaign/manage/banner/simple/" +
          campaignID,
        data,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  ویرایش تنظیمات نمایش کمپین بنری ساده
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              {messageTag}

              <div className="container-fluid">
                <div className="row">
                  <div className="col-12 ">
                    <form onSubmit={sendForm}>
                      <div className="col-12 col-md-6  ">
                        <label>نام کمپین</label>
                        <input
                          className="form-control"
                          id="name-campaign"
                          type="text"
                          defaultValue={campaign.name}
                        />
                      </div>

                      <div className="col-12 col-md-6 pt-2 ">
                        <label>گروه نمایش دهندگان</label>
                        <select id="category-campaign" className="form-control">
                          <option>انتخاب کنید</option>
                          {tagCategories}
                        </select>
                      </div>

                      <div className="col-12 col-md-6 pt-2">
                        <div>
                          <label>فعال</label>
                        </div>
                        <div>
                          <span>
                            <label className="adl-switch">
                              <input
                                type="checkbox"
                                defaultChecked={campaign.active}
                                id="active-campaign"
                              />
                              <span className="adl-slider round"></span>
                            </label>
                          </span>
                        </div>
                      </div>
                      <div className="col-12 col-md-6 pt-2">
                        <button type="submit" className="btn btn-primary">
                          ویرایش
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default EditCampaign;
